import Utils from '@/utils';
import { getArtworkArtistDisplayName } from '@/utils/artworkArtists';

import ArtworkImage from './ArtworkImage';

import './styles/InventoryCard.css';

export default function InventoryCard({ artworkData, type, children }) {
  const sourceArtwork = type === "draft" ? artworkData?.draft_container : artworkData;
  const artistName = getArtworkArtistDisplayName(sourceArtwork);

  return (
    <>
      <div className="inventory-card__container">
        <ArtworkImage
          image={
            type === "draft" ? 
              artworkData.draft_container.artwork_media.artwork_main_picture.image_id
              :
              artworkData.artwork_media.artwork_main_picture.image_id
          }
          imageClassName="inventory-card__image"
          imageTemplateClassName="inventory-card__image"
          forceSmaller={300}
        />

        <div className="inventory-card__info">
          <div className="inventory-card__title-section">
            <span className="inventory-card__big-text dots-on-overflow --title font-size-medium">
              {
                type === "draft" ?
                  artworkData.draft_container.artwork_about.artwork_title
                  :
                  artworkData.artwork_about.artwork_title
              }
            </span>

            <span className="inventory-card__text font-size-medium" style={{ flexShrink: "0" }}>
              {Utils.getDateInStringFromTimestamp(new Date(artworkData.artwork_flags?.sold_at ? artworkData.artwork_flags.sold_at : artworkData.createdAt).getTime())}
            </span>
          </div>

          <div className="inventory-card__details-section">
            <div className="inventory-card__details-text">
              <span className="inventory-card__text dots-on-overflow font-size-medium">
                by {artistName}
              </span>

              <span className="inventory-card__text dots-on-overflow font-size-medium">
                {
                  type === "draft" ?
                    artworkData.draft_container.artwork_about.artwork_medium
                    :
                    artworkData.artwork_about.artwork_medium
                }
              </span>

              <span className="inventory-card__text dots-on-overflow font-size-medium">
                {
                  type === "draft" ?
                    `${artworkData.draft_container.artwork_about.artwork_size.length} ${artworkData.draft_container.artwork_about.artwork_size.unit} x ${artworkData.draft_container.artwork_about.artwork_size.height} ${artworkData.draft_container.artwork_about.artwork_size.unit}`
                    :
                    `${artworkData.artwork_about.artwork_size.length} ${artworkData.artwork_about.artwork_size.unit} x ${artworkData.artwork_about.artwork_size.height} ${artworkData.artwork_about.artwork_size.unit}`
                }
              </span>
            </div>

            {children}
          </div>

          <span className="inventory-card__big-text dots-on-overflow font-size-medium">
            {
              type === "draft" ?
                Utils.getArtworkPrice(artworkData.draft_container.artwork_about.artwork_price, artworkData.draft_container.artwork_about.artwork_currency)
                :
                Utils.getArtworkPrice(artworkData.artwork_about.artwork_price, artworkData.artwork_about.artwork_currency)
            }
          </span>
        </div>
      </div>
    </>
  );
}
